import { Spinner, Wrapper } from 'components';

import { PageWrapper } from 'pages/Workshop/PageWrapper';

import { ShowingsTable } from '../ShowingsTable';
import { ShowingTabs } from '../ShowingTabs';
import styles from './styles.module.scss';
import { SearchPlaceholderView } from 'pages/Workshop/components/SearchPlaceholderView';
import { useSelector } from 'react-redux';
import { getShowingSearchSelector } from 'store/selectors/showingAggregate';

export const ShowingsContent = (props) => {
  const { isPending, showListView, fetchShowingAggregate, isSearchActive } = props;
  const { search } = useSelector(getShowingSearchSelector);

  if (isPending) return <Spinner loaderClassName={styles.loader} />;

  if (isSearchActive && !search) {
    return <SearchPlaceholderView />;
  }

  if (showListView) {
    return (
      <PageWrapper className={styles.showingPageWrapper} isHideFooter isContainer={false}>
        <Wrapper isPending={isPending}>
          <ShowingsTable />
        </Wrapper>
      </PageWrapper>
    );
  }

  return (
    <div className={styles.showingsContent}>
      <ShowingTabs fetchShowingAggregate={fetchShowingAggregate} />
    </div>
  );
};
